import { isNotNullish } from '@/utils/typing/is-nullish.predicate';
import { getValueByPath } from '../object/get-value-by-path.utils';

export function interpolateString(expr: string, params?: any, templateMatcher: RegExp = /{{\s?([^{}\s]*)\s?}}/g) {
    if (!expr || !params) {
        return expr;
    }

    return expr.replace(templateMatcher, (_substring: string, key: string) => {
        const interpolatedExpr = getValueByPath(params, key);
        return isNotNullish(interpolatedExpr) ? interpolatedExpr : null;
    });
}
